import React from 'react';
import '../../App.css';
// import Cards from '../Cards';
// import HeroSection from '../HeroSection';
// import Footer from '../Footer';

function Sermons() {
  return (
    <>
    <div className='hero-container sanctuary half'>
        <h1>Sermons</h1>
        </div>
        <div className='main sermons'>
        <iframe 
          tabIndex="-1" 
          width="1" 
          height="540" 
          src="https://embed.sermonaudio.com/browser/broadcaster/gcftx/?sort=newest&page_size=25&dark=true" 
          style={{"min-width": "100%", "max-width": "100%"}} 
          allow="autoplay" 
          frameBorder="0" 
          scrolling="no">
        </iframe>
        </div>
    </>
  );
}

export default Sermons;